import React, { Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import AddExpertQuestionTemplateSection from "./AddExpertQuestionTemplateSection";
import ListItem from "@material-ui/core/ListItem";
import ExpertQuestionTemplateSection from "./ExpertQuestionTemplateSection";
import Dialog from "@material-ui/core/Dialog";
import DisplayExpertQuestionTemplate from "./DisplayExpertQuestionTemplate";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import TaxonomySelector from "../taxonomy/TaxonomySelector";
import Divider from "@material-ui/core/Divider";
import axios, { discussionClient } from "../../AxiosClient";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import TreeView from "@material-ui/lab/TreeView";
import FormHelperText from "@material-ui/core/FormHelperText";
import { withSnackbar } from "notistack";
import TreeItem from "@material-ui/lab/TreeItem";
import Collapse from "@material-ui/core/Collapse";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { fade, makeStyles, withStyles } from "@material-ui/core/styles";
import { useSpring, animated } from "react-spring/web.cjs"; // web.cjs is required for IE 11 support
const styles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  iconContainer: {
    "& .close": {
      opacity: 0.3,
    },
    marginLeft: 7,
    paddingLeft: 18,
    borderLeft: `1px dashed ${fade(theme.palette.text.primary, 0.4)}`,
  },
});
// function Alert(props) {
//   return <MuiAlert elevation={6} variant="filled" {...props} />;
// }
function TransitionComponent(props) {
  const style = useSpring({
    from: { opacity: 0, transform: "translate3d(20px,0,0)" },
    to: {
      opacity: props.in ? 1 : 0,
      transform: `translate3d(${props.in ? 0 : 20}px,0,0)`,
    },
  });

  return (
    <animated.div style={style}>
      <Collapse {...props} />
    </animated.div>
  );
}
TransitionComponent.propTypes = {
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
};
class CreateExpertQuestionTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      openAddSection: false,
      currentId: null,
      selected: null,
      templateTitle: "",
      taxonomyId: 0,
      convertValueToJson: false,
      snackOpen: false,
      edit: false,
      taxonomyId: null,
      templateDescription: "",
    };
    this.slate = React.createRef();
  }
  componentDidMount() {
    if (this.props.edit) {
      let count = 1;
      let data = JSON.parse(this.props.editData.templateJson);
      data.map((item) => {
        item.id = count;
        count++;
      });
      this.setState({
        data,
        templateTitle: this.props.editData.name,
        taxonomyId: this.props.editData.taxonomyNodeId,
        templateDescription: this.props.editData.description,
      });
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.editData != this.props.editData && this.props.edit) {
      this.setState({
        data: JSON.parse(this.props.editData.templateJson),
        templateTitle: this.props.editData.name,
        taxonomyId: this.props.editData.taxonomyNodeId,
        templateDescription: this.props.editData.description,
      });
    }
  }
  setTaxonomyId = (taxNode) => {
    this.setState({ taxonomyId: taxNode.id });
  };
  addToParent = (data, parentId, array) => {
    array.map(
      (currentData) =>
        currentData.id === parentId
          ? (currentData.expandedFrom = [...currentData.expandedFrom, data])
          : this.addToParent(data, parentId, currentData.expandedFrom)
    );
  };
  changeValueMap = (value, id, array) => {
    array.map(
      (currentData) =>
        currentData.id === id
          ? (currentData.value = value)
          : this.changeValueMap(value, id, currentData.expandedFrom)
    );
  };

  changeValue = (value, id) => {
    let tempArray = [...this.state.data];
    this.changeValueMap(value, id, tempArray);
    this.setState({ data: tempArray });
  };
  replaceSectionMap = (value, id, array) => {
    array.map(
      (currentData, index) =>
        currentData.id === id
          ? (array[index] = value)
          : this.replaceSectionMap(value, id, currentData.expandedFrom)
    );
  };
  onDataConfirmed = (data, edit) => {
    let tempData = { ...data };
    if (tempData.type === "Checkbox") {
      tempData.values = [true, false];
    }
    let tempArray = [...this.state.data];
    if (!edit) {
      if (tempData.parentId) {
        this.addToParent(tempData, tempData.parentId, this.state.data);
      } else {
        tempArray = [...tempArray, tempData];
      }
    } else {
      this.replaceSectionMap(tempData, tempData.id, tempArray);
    }
    this.setState({
      data: tempArray,
      currentId: this.state.currentId + 1,
      openAddSection: false,
    });
    this.props.onTemplateChange({
      templateJson: tempArray,
      name: this.state.templateTitle,
      description: this.state.templateDescription,
    });
  };
  openCreateSection = (selected) => {
    this.setState({ selected: selected, openAddSection: true });
  };
  openCreateSectionEdit = (selected) => {
    this.setState({ selected: selected, openAddSection: true, edit: true });
  };
  render() {
    const { classes, t, forwardedRef } = this.props;
    return (
      <>
        <div style={{ display: "flex", flexDirection: "row", height: "100%" }}>
          <div style={{ width: "50%" }}>
            <DialogContent
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography variant="h6">
                {this.props.edit
                  ? t("edit_expert_question_template")
                  : t("create_expert_question_template_setup")}
              </Typography>
              <FormControl component="fieldset" style={{ width: "100%" }}>
                <TextField
                  fullWidth
                  onChange={(e) => {
                    this.setState({ templateTitle: e.target.value });
                    this.props.onTemplateChange({
                      templateJson: this.state.data,
                      name: e.target.value,
                      description: this.state.templateDescription,
                    });
                  }}
                  required
                  value={this.state.templateTitle}
                  label={<Trans i18nKey="template_title" />}
                  id="template-title"
                />
              </FormControl>
              <FormControl
                component="fieldset"
                style={{ width: "100%", marginTop: "16px" }}
              >
                <TextField
                  fullWidth
                  onChange={(e) => {
                    this.setState({ templateDescription: e.target.value });
                    this.props.onTemplateChange({
                      templateJson: this.state.data,
                      name: this.state.templateTitle,
                      description: e.target.value,
                    });
                  }}
                  value={this.state.templateDescription}
                  id="template-description"
                  multiline
                  rows="3"
                  label={<Trans i18nKey="global_description" />}
                />
              </FormControl>
              <FormControl
                component="fieldset"
                style={{ width: "100%", marginTop: "16px" }}
              >
                <TaxonomySelector
                  allowedSelections={["taxonomy"]}
                  onNodeSelected={(taxNode) => {
                    this.setState({ taxonomyId: taxNode.id });
                    this.props.taxonomyIdCreate(taxNode.id);
                  }}
                  filter={
                    this.state.taxonomyId
                      ? [{ id: this.state.taxonomyId, type: "taxonomy" }]
                      : []
                  }
                />
                <FormHelperText>
                  <Trans i18nKey="global_required" />
                </FormHelperText>
              </FormControl>
              <Typography variant="h6" style={{ marginTop: 10 }}>
                {t("create_expert_question_template_sections")}
              </Typography>
              <FormControl
                component="fieldset"
                style={{ width: "100%", maxHeight: "55%", overflow: "auto" }}
              >
                <TreeView
                  className={classes.root}
                  defaultExpanded={["1"]}
                  defaultCollapseIcon={<ExpandMoreIcon />}
                  defaultExpandIcon={<ChevronRightIcon />}
                >
                  {this.makeTree()}
                </TreeView>
              </FormControl>
              <div
                style={{ textAlign: "center", marginBottom: 30, marginTop: 10 }}
              >
                <Button
                  variant="outlined"
                  startIcon={<AddIcon />}
                  onClick={() =>
                    this.setState({
                      openAddSection: true,
                      selectedData: {},
                      selected: null,
                    })
                  }
                >
                  {t("create_expert_question_add_section")}
                </Button>
              </div>
            </DialogContent>
          </div>
          <Divider orientation="vertical" />
          <div
            style={{ display: "flex", flexDirection: "column", width: "50%" }}
            id="template-preview"
          >
            <DialogTitle>{this.state.templateTitle}</DialogTitle>
            <DialogContent>
              {this.state.data.length > 0 ? (
                <>
                  {this.state.data.map((section) => (
                    <DisplayExpertQuestionTemplate
                      changeValue={this.changeValue}
                      data={section}
                    />
                  ))}
                </>
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography variant="body2">
                    {t("create_expert_question_preview_no_sections")}
                  </Typography>
                </div>
              )}
            </DialogContent>
            {/* <DialogActions>
              <Button
                onClick={() => this.setState({ data: [], templateTitle: "" })}
                color="primary"
                style={{ marginLeft: 0, marginRight: "auto" }}
              >
                <Trans i18nKey="global_clear" />
              </Button>
              <Button
                onClick={this.createTemplate}
                color="primary"
                id="create-template-button"
                disabled={
                  this.state.data.length === 0 ||
                  !this.state.templateTitle ||
                  !this.state.taxonomyId
                }
              >
                <Trans i18nKey="global_create" />
              </Button>
            </DialogActions> */}
          </div>
          {this.state.openAddSection && (
            <Dialog
              open={this.state.openAddSection}
              onClose={() =>
                this.setState({
                  selected: null,
                  edit: false,
                  openAddSection: false,
                })
              }
              aria-labelledby="create-new-dialog-title"
              aria-describedby="create-new-dialog-description"
            >
              <AddExpertQuestionTemplateSection
                edit={this.state.edit}
                currentId={this.state.currentId}
                selected={this.state.selected}
                onClose={() =>
                  this.setState({
                    selected: null,
                    edit: false,
                    openAddSection: false,
                  })
                }
                onDataConfirmed={this.onDataConfirmed}
              />
            </Dialog>
          )}
        </div>
      </>
    );
  }
  deleteSection = (data) => {
    let tempData = [...this.state.data];
    this.deleteSectionMap(data, tempData);
    this.setState({ data: tempData });
  };
  deleteSectionMap = (data, array) => {
    array.map(
      (currentData, idx) =>
        currentData.id === data.id
          ? array.splice(idx, 1)
          : this.deleteSectionMap(data, currentData.expandedFrom)
    );
  };
  makeid = (length) => {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };
  makeTree = () => {
    return this.loopTree(this.state.data, []);
  };
  loopTree = (array) => {
    return array.map((data) => (
      <TreeItem
        className={this.props.classes.iconContainer}
        style={{ width: "97%" }}
        nodeId={data.id}
        label={
          <ExpertQuestionTemplateSection
            deleteSection={this.deleteSection}
            openCreateSectionEdit={this.openCreateSectionEdit}
            openCreateSection={this.openCreateSection}
            data={data}
          />
        }
      >
        {this.loopOptions(data.values, data.expandedFrom)}
      </TreeItem>
    ));
  };
  loopOptions = (options, array) => {
    let asd = [];
    options.forEach((option) => {
      if (array.filter((e) => e.queryValue === option).length > 0) {
        asd.push(
          <TreeItem
            nodeId={this.makeid(9)}
            className={this.props.classes.iconContainer}
            label={`when "${option}" is selected, show:`}
          >
            {this.loopTree(array.filter((e) => e.queryValue === option))}
          </TreeItem>
        );
      }
    });
    return asd;
  };
  // clearValues = (array) => {
  //   array.map((item) => {
  //     item.value = null;
  //     this.clearValues(item.expandedFrom);
  //   });
  // };
  // createTemplate = () => {
  //   let tempData = [...this.state.data];
  //   this.clearValues(tempData);
  //   discussionClient
  //     .post(`taxonomynode/${this.state.taxonomyId}/expertquestiontemplate/`, {
  //       templateJson: JSON.stringify(tempData),
  //       name: this.state.templateTitle,
  //       description: this.state.templateDescription,
  //     })
  //     .then((res) => {
  //       this.props.enqueueSnackbar(
  //         this.props.t("template_has_been_created_snackbar"),
  //         { variant: "success" }
  //       );
  //     })
  //     .catch(() => {
  //       this.props.enqueueSnackbar("", { variant: "error" });
  //     });
  // };
}

export default withTranslation()(
  withStyles(styles)(withSnackbar(CreateExpertQuestionTemplate))
);
